import React from "react";
import { useSelector } from "react-redux";

const LoadingComponent = () => {
  const darkMode = useSelector((state) => state.settings?.darkMode || false);

  const bgColor = darkMode ? "bg-[#050A14]" : "bg-[#f5f7fb]";
  const textColor = darkMode ? "text-white" : "text-[#3f51b5]";
  const innerColor = darkMode ? "text-[#050A14]" : "text-[#f5f7fb]";

  return (
    <>
      <style>
        {`
          @keyframes floatLogo {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
          }
          @keyframes pulseGlow {
            0%, 100% { opacity: 0.2; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(1.2); }
          }
          @keyframes dotWave {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes innerDotPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.3); opacity: 0.7; }
          }
          .animate-float {
            animation: floatLogo 3s ease-in-out infinite;
          }
          .animate-glow {
            animation: pulseGlow 3s ease-in-out infinite;
          }
          .animate-inner-dot {
            transform-origin: center;
            animation: innerDotPulse 1.5s ease-in-out infinite;
          }
          .loading-dot {
            animation: dotWave 1.2s ease-in-out infinite;
          }
        `}
      </style>
      <div className={`fixed inset-0 flex flex-col items-center justify-center z-[9999] transition-colors duration-300 ${bgColor}`}>
        {/* Animated Logo */}
        <div className="relative flex flex-col items-center justify-center">
          {/* Glow effect */}
          <div className={`absolute w-32 h-32 blur-3xl rounded-full animate-glow ${darkMode ? 'bg-white' : 'bg-[#3f51b5]'}`}></div>

          <svg 
            viewBox="0 0 100 100" 
            width="120" 
            height="120" 
            className={`relative z-10 animate-float ${textColor}`}
          >
            {/* Shield Base */}
            <path 
              d="M 12 28 Q 50 12 50 12 Q 50 12 88 28 C 88 65, 68 88, 50 96 C 32 88, 12 65, 12 28 Z" 
              fill="currentColor"
            />
            {/* Inner Cutout (Background color) */}
            <circle cx="50" cy="52" r="18" className={`fill-current ${innerColor}`} />
            {/* Center Dot (Foreground color) */}
            <circle cx="50" cy="52" r="8" fill="currentColor" className="animate-inner-dot" />
          </svg>

          {/* Text */}
          <div className={`mt-8 text-4xl font-bold tracking-[0.2em] uppercase transition-colors duration-300 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            RAQIB
          </div>

          {/* Loading Dots */}
          <div className="flex gap-3 mt-6">
            <div className={`w-3 h-3 rounded-full loading-dot ${darkMode ? 'bg-white' : 'bg-[#3f51b5]'}`} style={{ animationDelay: "0s" }}></div>
            <div className={`w-3 h-3 rounded-full loading-dot ${darkMode ? 'bg-white' : 'bg-[#3f51b5]'}`} style={{ animationDelay: "0.2s" }}></div>
            <div className={`w-3 h-3 rounded-full loading-dot ${darkMode ? 'bg-white' : 'bg-[#3f51b5]'}`} style={{ animationDelay: "0.4s" }}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingComponent;
